import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-show-more',
  standalone: true,
  imports: [
    MatIcon,
    NgIf
  ],
  templateUrl: './show-more.component.html',
  styleUrl: './show-more.component.scss'
})
export class ShowMoreComponent implements OnInit, OnDestroy{

  private scrollPosition = 0;
  private element;
  isBottom = false;

  ngOnInit() {
    this.element = document.getElementById('js-scrollDown');
    if (this.element) {
      this.element.addEventListener('scroll', this.onScroll.bind(this));
    }
  }

  ngOnDestroy() {
    if (this.element) {
      this.element.removeEventListener('scroll', this.onScroll.bind(this));
    }
  }

  onScroll() {
    if (this.element) {
      this.scrollPosition = this.element.scrollTop;
      if (!this.isBottom) {
        this.isBottom = this.scrollPosition >= (this.element.scrollHeight - this.element.offsetHeight) - 20;
      }
    }
  }

  /**
   * Scroll
   *  - jusqu'à la moitié de l'élément (si le scroll est plus haut que la moitié)
   *  - jusqu'à la fin de l'élément (si le scroll est plus bas que la moitié)
   *
   * Cache le bouton une fois en bas (ne réapparaît pas)
   */
  scrollDown():void {
    if (this.element) {
      if (this.scrollPosition >= (this.element.scrollHeight - this.element.offsetHeight) / 2) {
        this.scrollPosition = (this.element.scrollHeight - this.element.offsetHeight);
      } else {
        this.scrollPosition = Math.ceil((this.element.scrollHeight - this.element.offsetHeight) / 2);
      }
      this.element.scroll({
        top: this.scrollPosition,
        left: 0,
        behavior: 'smooth'
      });
      this.isBottom = this.scrollPosition == (this.element.scrollHeight - this.element.offsetHeight);
    }
  }

}
